/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'ip-addr-match';
const prefix = `${moduleName}.${componentName}`;

export const ipAddressLabel = `${prefix}.ipAddressLabel`;
export const addItemButtonLabel = `${prefix}.addItemButtonLabel`;

export const ENGLISH = {
    [ipAddressLabel]: 'IP Address',
    [addItemButtonLabel]: 'Add Item',
};
